export const destination = [
  ["ALBANIA", "Elbasan"],
  ["ANDORA", "Andorra la Vella"],
  ["AUSTRIA", "Graz", "Innsbruck", "Klagenfurt am Worthersee", "Linz", "Salzburg", "Vienna"],
  ["BELGIA", "Antwerp", "Brussels", "Liege"],
  ["BOŚNIA I HERCEGOWINA", "Banja Luka", "Doboj", "Lukavac", "Mostar", "Sarajevo", "Zenica"],
  [
    "BUŁGARIA",
    "Blagoevgrad",
    "Burgas",
    "Karlovo",
    "Kozloduy",
    "Montana",
    "Pernik",
    "Pirdop",
    "Pleven",
    "Plovdiv",
    "Ruse",
    "Sofia",
    "Varna",
    "Veliko Tarnovo",
    "Vidin",
  ],
  [
    "CHORWACJA",
    "Dubrovnik",
    "Osijek",
    "Ploce",
    "Pula",
    "Rijeka",
    "Senj",
    "Slavonski Brod",
    "Split",
    "Virovitica",
    "Zadar",
    "Zagreb",
    "Sibenik",
  ],
  ["CYPR", "Larnaca", "Limassol", "Nicosia", "Paphos"],
  ["CZECHY", "Brno", "Jihlava", "Mlada Boleslav", "Olomouc", "Ostrava", "Prague"],
  [
    "DANIA",
    "Aalborg",
    "Aarhus",
    "Copenhagen",
    "Esbjerg",
    "Frederikshavn",
    "Gedser",
    "Herning",
    "Hirtshals",
    "Holstebro",
    "Kolding",
    "Odense",
    "Padborg",
    "Ronne",
    "Vestero Havn",
    "Viborg",
  ],
  ["EGIPT", "Arish", "Damietta", "Port Said", "Taba"],
  ["ESTONIA", "Kunda", "Kuressaare", "Narva", "Paldiski", "Parnu", "Tallinn", "Tartu", "Valga"],
  ["WYSPY OWCZE", "Klaksvik", "Torshavn"],
  [
    "FINLANDIA",
    "Alajarvi",
    "Helsinki",
    "Ivalo",
    "Joensuu",
    "Jyvaskyla",
    "Kaustinen",
    "Kemi",
    "Kemijarvi",
    "Kittila",
    "Kokkola",
    "Kotka",
    "Kouvola",
    "Kristinestad",
    "Kuopio",
    "Karsamaki",
    "Lahti",
    "Loviisa",
    "Mikkeli",
    "Muonio",
    "Naantali",
    "Olkiluoto",
    "Oulu",
    "Pello",
    "Pori",
    "Rovaniemi",
    "Savonlinna",
    "Seinajoki",
    "Sodankyla",
    "Tampere",
    "Tornio",
    "Turku",
    "Utsjoki",
    "Vaasa",
    "Vantaa",
    "Varkaus",
    "Viitasaari",
    "Ylivieska",
  ],
  [
    "FRANCJA",
    "Ajaccio",
    "Bastia",
    "Bayonne",
    "Bonifacio",
    "Bordeaux",
    "Bourges",
    "Brest",
    "Calais",
    "Calvi",
    "Civaus",
    "Clermont-Ferrand",
    "Dax",
    "Dijon",
    "Foix",
    "Golfech",
    "Granville",
    "Llle-Rousse",
    "La Rochelle",
    "Lacq",
    "Le Havre",
    "Le Mans",
    "Lille",
    "Limoges",
    "Lyon",
    "Marseille",
    "Metz",
    "Montpellier",
    "Mulhouse",
    "Nantes",
    "Narbonne",
    "Nice",
    "Orleans",
    "Paluel",
    "Paris",
    "Perpignan",
    "Port-Vendres",
    "Port-Vecchio",
    "Reims",
    "Rennes",
    "Roscoff",
    "Saint-Alban-du-Rhone",
    "Saint-Laurent",
    "Strasbourg",
    "Toulouse",
    "Valenciennes",
  ],
  ["GRUZJA", "Batumi", "Poti"],
  [
    "NIEMCY",
    "Anklam",
    "Aurach",
    "Bad Oeynhausen",
    "Berlin",
    "Bonn",
    "Bremen",
    "Bremerhaven",
    "Burg auf Fehmarn",
    "Chemnitz",
    "Cologne",
    "Dortmund",
    "Dresden",
    "Duisburg",
    "Dusseldorf",
    "Erfurt",
    "Flensburg",
    "Forst (Lausitz)",
    "Frankfurt am Main",
    "Furth",
    "Halle (Saale)",
    "Hamburg",
    "Hanover",
    "Heilbronn",
    "Kassel",
    "Kiel",
    "Koblenz",
    "Leipzig",
    "Magdeburg",
    "Mainz",
    "Mannheim",
    "Munich",
    "Nuremberg",
    "Oberhausen",
    "Osnabruck",
    "Rostock",
    "Sangerhausen",
    "Soltau",
    "Stuttgart",
    "Travemunde",
    "Uelzen",
    "Werlte",
    "Wiesbaden",
  ],
  ["GRECJA", "Alexandroupoli", "Ioannina", "Kavala", "Ptolemaida", "Serres", "Thessaloniki"],
  ["WĘGRY", "Budapest", "Debrecen", "Gyor", "Szeged", "Szombathely", "Sumeg", "Vasarosnameny"],
  [
    "ISLANDIA",
    "Akranes",
    "Akureyri",
    "Blonduos",
    "Bolungarvik",
    "Borgarnes",
    "Garpsdalur",
    "Holmavik",
    "Hofn i Hornafiroi",
    "Keflavik",
    "Krafla",
    "Norourfjorour",
    "Reykjavik",
    "Reyoarfjordur",
    "Selfoss",
    "Seydisfjordur",
    "Stykkisholmur",
    "Sudureyri",
    "Varmahlid",
    "Vestmannaeyjar",
    "Vik i Myrdal",
    "Isafjordur",
    "Olafsvik",
    "Porlakshofn",
  ],
  ["IRAK", "Al-Qaim", "Ar-Rutbah", "Baiji", "Haditha", "Hit"],
  ["IRLANDIA", "Dublin", "Galway", "Limerick", "Sligo", "Wexford"],
  [
    "IZRAEL",
    "Acre",
    "Afula",
    "Ashdod",
    "Ashkelon",
    "Beersheba",
    "Beit Shean",
    "Dimona",
    "Eilat",
    "Ein Gedi",
    "Hadera",
    "Haifa",
    "Herzliya",
    "Jerusalem",
    "Kiryat Shmona",
    "Mitzpe Ramon",
    "Nazareth",
    "Netanya",
    "Rishon LeZion",
    "Tel Aviv",
    "Tiberias",
  ],
  [
    "WŁOCHY",
    "Ancona",
    "Bari",
    "Bologna",
    "Cagliari",
    "Cassino",
    "Catania",
    "Catanzaro",
    "Florence",
    "Genoa",
    "Livorno",
    "Messina",
    "Milan",
    "Naples",
    "Olbia",
    "Palermo",
    "Parma",
    "Pescara",
    "Rome",
    "Sassari",
    "Suzzara",
    "Syracuse",
    "Taranto",
    "Terni",
    "Trieste",
    "Turin",
    "Venice",
    "Verona",
    "Villa San Giovanni",
  ],
  ["JERSEY", "Saint Helier", "Trinity"],
  [
    "JORDANIA",
    "Al-Karak",
    "Amman",
    "Aqaba",
    "Irbid",
    "Jerash",
    "Maan",
    "Madaba",
    "Mafraq",
    "Ruwaished",
    "Safawi",
    "Zarqa",
  ],
  [
    "ŁOTWA",
    "Balvi",
    "Daugavpils",
    "Jekabpils",
    "Kolka",
    "Liepaja",
    "Riga",
    "Rezekne",
    "Valmiera",
    "Ventspils",
  ],
  ["LIBAN", "Baalbek", "Beirut", "Byblos", "Nabatieh", "Sidon", "Tripoli", "Tyre", "Zahle"],
  ["LITWA", "Kaunas", "Klaipeda", "Mazeikiai", "Panevezys", "Taurage", "Ukmerge", "Utena", "Vilnius", "Siauliai"],
  ["LUKSEMBURG", "Luxembourg"],
  ["MALTA", "Valletta"],
  ["MOŁDAWIA", "Balti", "Chisinau", "Giurgiulesti"],
  ["HOLANDIA", "Amsterdam", "Arnhem", "Eindhoven", "Groningen", "Moerdijk", "Rotterdam", "Zwolle"],
  [
    "NORWEGIA",
    "Alta",
    "Bergen",
    "Berlevag",
    "Bidjovagge",
    "Batsfjord",
    "Dombas",
    "Drammen",
    "Hamar",
    "Hammerfest",
    "Honningsvag",
    "Karasjok",
    "Kautokeino",
    "Kirkenes",
    "Kjollefjord",
    "Kristiansand",
    "Kristiansund",
    "Lakselv",
    "Lebesby",
    "Lillehammer",
    "Mehamn",
    "Molde",
    "Oppdal",
    "Orkanger",
    "Oslo",
    "Otta",
    "Stavanger",
    "Storslett",
    "Tana bru",
    "Tromso",
    "Trondheim",
    "Vadso",
    "Vardo",
    "Andalsnes",
  ],
  [
    "POLSKA",
    "Augustów",
    "Białystok",
    "Bielsko-Biała",
    "Bobolice",
    "Chełm",
    "Cieszyn",
    "Człuchów",
    "Dziwnów",
    "Dziwnówek",
    "Elbląg",
    "Ełk",
    "Gdańsk",
    "Gdynia",
    "Gorzów Wielkopolski",
    "Grudziądz",
    "Janów",
    "Jaworznia",
    "Katowice",
    "Kielce",
    "Koszalin",
    "Kraków",
    "Kłodzko",
    "Krosno",
    "Lublin",
    "Łeba",
    "Lębork",
    "Legnica",
    "Międzyzdroje",
    "Mikołajki",
    "Mława",
    "Nowogard",
    "Olsztyn",
    "Olszyna",
    "Opatów",
    "Ostróda",
    "Opole",
    "Ostrołęka",
    "Ostrów Mazowiecka",
    "Poznań",
    "Piła",
    "Przemyśl",
    "Przasnysz",
    "Płock",
    "Radom",
    "Reda",
    "Rumia",
    "Rzeszów",
    "Rusinowo",
    "Sanok",
    "Siedlce",
    "Sopot",
    "Stargard",
    "Szumowo",
    "Szczecinek",
    "Suwałki",
    "Szczecin",
    "Warszawa",
    "Wejherowo",
    "Wałcz",
    "Wrocław",
    "Zamość",
    "Zambrów",
    "Zgierz",
    "Zgorzelec",
    "Łódź",
    "Świnoujście",
  ],
  [
    "PORTUGALIA",
    "Beja",
    "Coimbra",
    "Corticadas de Lavre",
    "Evora",
    "Faro",
    "Guarda",
    "Lisbon",
    "Olhao",
    "Ponte de Sor",
    "Porto",
    "Setubal",
    "Sines",
  ],
  [
    "RUMUNIA",
    "Bacau",
    "Brasov",
    "Bucharest",
    "Cernavoda",
    "Cluj-Napoca",
    "Constanta",
    "Craiova",
    "Calarasi",
    "Galati",
    "Hunedoara",
    "Iasi",
    "Mangalia",
    "Pitesti",
    "Resita",
    "Satu Mare",
    "Timisoara",
    "Targu Mures",
  ],
  [
    "ROSJA",
    "Gusev",
    "Kaliningrad",
    "Kandalaksha",
    "Luga",
    "Murmansk",
    "Nikel",
    "Pskov",
    "Saint Petersburg",
    "Sosnovy Bor",
    "Verkhnetulomsky",
    "Vyborg",
    "Zelenogradsk",
  ],
  ["SERBIA", "Belgrade", "Kragujevac", "Leskovac", "Nis", "Novi Sad", "Pancevo", "Subotica", "Vranje", "Zrenjanin"],
  ["SŁOWACJA", "Banska Bystrica", "Bratislava", "Kosice", "Michalovce", "Trnava", "Zvolen"],
  ["SŁOWENIA", "Koper", "Ljubljana", "Maribor"],
  [
    "HISZPANIA",
    "A Coruna",
    "Albacete",
    "Algeciras",
    "Almaraz",
    "Almeria",
    "Badajoz",
    "Bailen",
    "Barcelona",
    "Bilbao",
    "Burgos",
    "Canfranc-Estacion",
    "Ciudad Real",
    "Contreras",
    "Cordoba",
    "El Ejido",
    "Gijon",
    "Granada",
    "Huelva",
    "Huesca",
    "Jaca",
    "La Jonquera",
    "Leon",
    "Lleida",
    "Llivia",
    "Madrid",
    "Mengibar",
    "Murcia",
    "Malaga",
    "Navia",
    "O Barco",
    "Pamplona",
    "Port de Sagunt",
    "Puertollano",
    "Salamanca",
    "Santander",
    "Seville",
    "Soria",
    "Tarragona",
    "Teruel",
    "Valencia",
    "Valladolid",
    "Vandellos",
    "Vigo",
    "Villarreal",
    "Zaragoza",
  ],
  ["SVALBARD", "Grumantbyen", "Hiorthhamn", "Longyearbyen"],
  [
    "SZWECJA",
    "Gothenburg",
    "Gavle",
    "Haparanda",
    "Helsingborg",
    "Jonkoping",
    "Kalix",
    "Kalmar",
    "Kapellskar",
    "Karesuando",
    "Karlskrona",
    "Karlstad",
    "Kristianstad",
    "Linkoping",
    "Lulea",
    "Malmo",
    "Nynashamn",
    "Skelleftea",
    "Stockholm",
    "Sundsvall",
    "Soderhamn",
    "Sodertalje",
    "Trelleborg",
    "Umea",
    "Uppsala",
    "Visby",
    "Vasteras",
    "Vaxjo",
    "Ystad",
    "Orebro",
    "Ornskoldsvik",
    "Ostersund",
  ],
  ["SZWAJCARIA", "Basel", "Bern", "Geneva", "Zurich"],
  ["SYRIA", "Al-Sanamayn", "Damascus", "Deraa", "Izra", "Latakia", "Tartus"],
  ["TURCJA", "Antakya", "Edirne", "Mersin", "Osmaniye", "Tekirdag", "Iskenderun", "Istanbul"],
  [
    "UKRAINA",
    "Chernivtsi",
    "Ivano-Frankivsk",
    "Kovel",
    "Lutsk",
    "Lviv",
    "Mukachevo",
    "Novovolynsk",
    "Polyanytsya",
    "Stryi",
    "Uzhhorod",
    "Varash",
  ],
  [
    "WIELKA BRYTANIA",
    "Aberdeen",
    "Aberystwyth",
    "Balivanich",
    "Birmingham",
    "Birsay",
    "Broadford",
    "Cairnryan",
    "Cambridge",
    "Canterbury",
    "Cardiff",
    "Carlisle",
    "Chelmsford",
    "Croydon",
    "Dover",
    "Dumfries",
    "Edinburgh",
    "Evie",
    "Exeter",
    "Felixstowe",
    "Fishguard",
    "Folekstone",
    "Fort William",
    "Fraserburgh",
    "Glasgow",
    "Grimsby",
    "Hawes",
    "Holyhead",
    "Hull",
    "Inverness",
    "Kirkwall",
    "Liverpool",
    "Lochboisdale",
    "London",
    "Manchester",
    "Newcastle upon Tyne",
    "Norwich",
    "Oban",
    "Perth",
    "Plymouth",
    "Porthmadog",
    "Portree",
    "Portsmouth",
    "Sheffield",
    "Southampton",
    "Stornoway",
    "Stranraer",
    "Swansea",
    "Thurso",
    "Ullapool",
    "Wick",
  ],
  ["ZACHODNI BRZEG", "Bethlehem", "Gaza", "Jericho", "Ramallah"],
];
